import { getToken } from '@optimus-web/common';
import { ChipProps } from './Chip';

type State = 'disabled' | 'error' | 'default';
type ChipTokenConfig = Record<State, ReturnType<typeof getToken>>;
type Props = Pick<ChipProps, 'disabled' | 'error' | 'readOnly'>;

export const getState = (props: Props) => {
    let state: State = 'default';

    if (props?.disabled) {
        state = 'disabled';
    } else if (props?.error) {
        state = 'error';
    }

    return { state };
};

export const getBackgroundColor = (props: Props) => {
    const backgroundColorTokens: ChipTokenConfig = {
        disabled: getToken('backgroundDisabled'),
        error: getToken('backgroundAlertDangerSecondary'),
        default: getToken('backgroundInteractiveNeutralDefault'),
    };

    const { state } = getState(props);
    return backgroundColorTokens[state];
};

export const getHoverBackgroundColor = (props: Props) => {
    const hoverBackgroundColorTokens: ChipTokenConfig = {
        disabled: getToken('backgroundDisabled'),
        error: getToken('backgroundAlertDangerSecondary'),
        default: getToken('backgroundInteractiveNeutralHover'),
    };

    const { state } = getState(props);
    return hoverBackgroundColorTokens[state];
};

export const getActiveBackgroundColor = (props: Props) => {
    const activeBackgroundColorTokens: ChipTokenConfig = {
        disabled: getToken('backgroundDisabled'),
        error: getToken('backgroundAlertDangerSecondary'),
        default: getToken('backgroundInteractiveNeutralActive'),
    };

    const { state } = getState(props);
    return activeBackgroundColorTokens[state];
};

export const getColor = (props: Props) => {
    const colorTokens: ChipTokenConfig = {
        disabled: props?.readOnly ? getToken('textStaticPrimary') : getToken('textDisabled'),
        error: getToken('textAlertDanger'),
        default: getToken('textStaticPrimary'),
    };

    const { state } = getState(props);
    return colorTokens[state];
};

export const getHoverColor = (props: Props) => {
    const hoverColorTokens: ChipTokenConfig = {
        disabled: getToken('textDisabled'),
        error: getToken('textAlertDanger'),
        default: getToken('textStaticPrimary'),
    };

    const { state } = getState(props);
    return hoverColorTokens[state];
};

export const getActiveColor = (props: Props) => {
    const activeColorTokens: ChipTokenConfig = {
        disabled: getToken('textDisabled'),
        error: getToken('textAlertDanger'),
        default: getToken('textStaticPrimary'),
    };

    const { state } = getState(props);
    return activeColorTokens[state];
};
